(function($){
    'use strict';

    function resourcesSorting() {
        
        let $filtersWrapper = $('.resource--filters');

        if ($filtersWrapper.length >= 0) {
            let $grid = $('.resource--cards');
            let $resourceTypeFilter = $('#tg_resource_type_filter');
            let $resourceIndustryFilter = $('#tg_resource_industry_filter');
            let $resourceTypeSearch = $('#resource_type');
            let $resourceIndustrySearch = $('#resource_industry');

            $resourceTypeFilter.on('change', (element) => {
                let $currentValue = $(element.target).val();
                $resourceTypeSearch.val($currentValue.substring(1));
            });

            $resourceIndustryFilter.on('change', (element) => {
                let $currentValue = $(element.target).val();
                $resourceIndustrySearch.val($currentValue.substring(1));
            });

            // Combining both filters into one object
            let $filters = $.merge($resourceTypeFilter, $resourceIndustryFilter);

            $grid.isotope({
                animationOptions: {
                    duration: 750,
                    easing: 'linear',
                    queue: false,
                }
            });

            // Run Isotope filter on Resource type selection
            if ($filters.length >= 0) {
                $filters.on('change', function() {
                    let $values = [];
                    $filters.each( function(index, element) {
                        //Capture selected values from all choosers
                        $values.push($(element).val());
                    })
                    $values = $values.join('');
                    
                    $grid.isotope({
                        filter: $values ? $values : '*',
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false,
                        }
                    });

                    return false;
                })
            }
        }
    }

    resourcesSorting();

    $(window).on('load', function() {
        resourcesSorting();
    });

    $(window).on("scroll", function() { 
        resourcesSorting();
    });
   
    $(window).on("resize", function() {
        resourcesSorting();
    });

})(jQuery); 
